var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z","fill":"#63666A","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.5034 31V21.1H24.5091L25 16.7H21.5034V14.5572C21.5034 13.4242 21.5324 12.3 23.1156 12.3H24.7192V9.154C24.7192 9.1067 23.3417 9 21.9483 9C19.038 9 17.2157 10.8227 17.2157 14.17V16.7H14V21.1H17.2157V31H21.5034Z","fill":"white","key":1})]);
}

Facebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
